import React from 'react';
import {useTranslation} from 'react-i18next';
import {s} from '@/app/utils/s';
import Space, {spaceSizes} from '@/app/components/Space';
import AuthTitle from '@/app/features/auth/components/auth_title';
import Button from "@/app/components/button";
import styles from "@/app/features/auth/pages/create_pin/styles.module.scss";
import useWhoAreYou from "@/app/features/auth/pages/who_are_you/slice";
import RadioWidget from "@/app/features/auth/components/radio_item/index";

const WhoAreYouWidget = () => {
  const {t} = useTranslation();
  const {
    selectedItem,
    setSelectedItem,
    items,
    next,
  } = useWhoAreYou();

  return (
    <div className={styles.main} id="main">
      <AuthTitle title={t(s.whoAreYou)} subtitle={t(s.specifyYourRole)}/>
      <Space h={spaceSizes.s50}/>
      <RadioWidget
        items={items} selectedItem={selectedItem} setSelectedItem={(item) => setSelectedItem(item)}
      />
      <Space h={spaceSizes.s20}/>
      <Button
        isLoading={false}
        isDisabled={selectedItem === null}
        onClick={() => next()}
      >
        {s.continue}
      </Button>
    </div>
  );
};

export default WhoAreYouWidget;